"use strict";

var __async = window.__async;
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = value => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = value => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = x => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { fetchWithCsrf } from "js/utils/fetch_with_csrf";
import { routes } from "js/utils";
import { updateButtons } from "js/profiles/setUpLeftSidebarButtons";
Aedu.ResearchInterestListCard = class ResearchInterestListCard extends HoverPopover {
  initialize(options) {
    super.initialize({
      html: true,
      placement: "bottom",
      container: this.cardContainer(),
      show_delay: 400,
      hide_delay: 250,
      content: () => this.cardContent(),
      template: (() =>
      // Maybe we should alwaays just use our own template?
      $($.fn.popover.Constructor.DEFAULTS.template).addClass("popover-hovercard ri-list-card"))()
    });
    this.list = this.getResearchInterestListFromOptions(options);
    if (this.list != null) {
      this.on_shown = popoverElement => {
        this.activateFollowAndUnfollowButtons();
        this.showStats(popoverElement);
      };
    }
    return Aedu.Behaviors.ScrollScope.enable(this._popover_el().find(".popover-content"));
  }
  getResearchInterestListFromOptions(options) {
    let ri;
    const ri_id = this.$el.data("remove-ri");
    const riList = [];
    if (options.work.research_interests != null) {
      for (ri of Array.from(options.work.research_interests)) {
        if (ri.id !== ri_id) {
          riList.push(new Aedu.ResearchInterest(ri));
        }
      }
    } else if (options.work.interests != null) {
      for (ri of Array.from(options.work.interests)) {
        if (ri.id !== ri_id) {
          riList.push(new Aedu.ResearchInterest(ri));
        }
      }
    }
    if (Aedu.User.current != null) {
      return _(riList).sortBy(r => !Aedu.User.current.has_interest(r.id));
    } else {
      return riList;
    }
  }
  showStats($popover) {
    return Array.from(this.list).map(ri =>
    // do ensures that we have the correct selector when the done callback is executed
    function () {
      const selector = `*[data-stats-for-ri=${ri.get("id")}] .js-ri-card-stat-num[data-stat=followers_count]`;
      return ri.loadFollowersCount().done(c => $popover.find(selector).text($h.commaizeInt(c)));
    }());
  }
  activateFollowAndUnfollowButtons() {
    document.querySelectorAll("[data-follow-ri-id]").forEach(element => {
      element.addEventListener("click", e => __async(this, null, function* () {
        e.preventDefault();
        const el = e.currentTarget;
        const researchInterestId = el.getAttribute("data-follow-ri-id");
        const res = yield followRI(researchInterestId);
        updateButtons(el, `[data-unfollow-ri-id="${researchInterestId}"]`, res.ok);
      }));
    });
    document.querySelectorAll("[data-unfollow-ri-id]").forEach(element => {
      element.addEventListener("click", e => __async(this, null, function* () {
        if (!Aedu.User.current) {
          return;
        }
        e.preventDefault();
        const el = e.currentTarget;
        const researchInterestId = el.getAttribute("data-unfollow-ri-id");
        const res = yield unfollowRI(researchInterestId);
        updateButtons(el, `[data-follow-ri-id="${researchInterestId}"]`, res.ok);
      }));
    });
    const followRI = researchInterestId => __async(this, null, function* () {
      const res = yield postFollowRI(researchInterestId, routes.add_api_v0_taggings_path({
        subdomain_param: "api",
        tag_type: "ResearchInterest",
        target_type: "User",
        target_id: Aedu.User.current.id
      }));
      const data = yield res.json();
      Aedu.User.current && Aedu.User.current.record_interest_of(data.research_interest);
      return res;
    });
    const unfollowRI = researchInterestId => __async(this, null, function* () {
      const res = yield postFollowRI(researchInterestId, routes.remove_api_v0_taggings_path({
        subdomain_param: "api",
        tag_type: "ResearchInterest",
        target_type: "User",
        target_id: Aedu.User.current.id
      }));
      Aedu.User.current && Aedu.User.current.record_uninterest_of(researchInterestId);
      return res;
    });
    const postFollowRI = (researchInterestId, url) => __async(this, null, function* () {
      const response = yield fetchWithCsrf(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          tag: {
            id: researchInterestId
          }
        })
      });
      return response;
    });
  }
  cardContent() {
    return JST["core_post_webpack/sitewide_business_elements/research_interest_list_card/templates/card"]({
      ris: this.list
    });
  }
  cardContainer() {
    if (!this.$el.parent().is("div, li") || !this.$el.parents(".bootstrap").length) {
      return "#bootstrap-modal-container";
    }
  }
};
window.__async = __async;
window.fetchWithCsrf = fetchWithCsrf;
window.routes = routes;
window.updateButtons = updateButtons;